import { Box, Paper, Avatar, Button } from "@mui/material";

import { IUserList } from "../interfaces";

const UserListItem: React.FC<IUserList> = ({
  isMobile,
  user,
  handleFollow,
  handleUnfollow,
  isFollow,
  goToProfile,
  isShowButtom,
}) => {
  console.log(isFollow);
  return isMobile ? (
    <Paper elevation={1} style={{ padding: 12, marginBottom: 8 }}>
      <Box style={{ display: "flex", alignItems: "center" }}>
        <Box onClick={() => goToProfile(user.username)}>
          <Avatar src={user.avatar ? user.avatar : ""} />
        </Box>
        <Box
          style={{ marginLeft: 8 }}
          onClick={() => goToProfile(user._id || "")}
        >
          <Box>{user.username}</Box>
          <Box>{user.email}</Box>
        </Box>
        {isShowButtom && (
          <Box style={{ marginLeft: "auto" }}>
            {isFollow ? (
              <Button
                onClick={() => handleUnfollow(user.username)}
                color="secondary"
                variant="outlined"
                style={{
                  color: "rgb(0 127 255 / 74%)",
                  width: 30,
                  height: 30,
                  fontSize: 14,
                  textTransform: "capitalize",
                  border: "1px solid rgb(0 127 255 / 74%)",
                }}
              >
                Unfollow
              </Button>
            ) : (
              <Button
                onClick={() => handleFollow(user.username)}
                color="secondary"
                disableElevation
                variant="contained"
                style={{
                  color: "#FFFFFF",
                  width: 30,
                  height: 30,
                  fontSize: 14,
                  textTransform: "capitalize",
                }}
              >
                Follow
              </Button>
            )}
          </Box>
        )}
      </Box>
    </Paper>
  ) : (
    <>UserListDesktop</>
  );
};

export default UserListItem;
